export const types = {
    SET_PLAYER_VOLUME: 'SET_PLAYER_VOLUME',
    SET_PLAYER_QUALITY: 'SET_PLAYER_QUALITY',
    SET_PLAYER_SPEED: 'SET_PLAYER_SPEED',

    SET_MUTE: 'SET_MUTE',
};
